module.exports = __webpack_public_path__ + "static/img/hb_44-min.b7beb78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_44-min.png
// module id = /G1W
// module chunks = 1